<template>
    <div class="container py-5">
        <div class="row">
            <div class="col-md-8 col-lg-7 col-xl-6 mx-auto">
                <h6 class="text-center font-weight-300 mb-4">
                    <span v-if="!paymentSuccess">That didn't go so well ...</span>
                    <span v-else-if="$route.path.includes('complete')">Complete Transaction</span>
                    <span v-else>You're Almost There!</span>
                </h6>
                <div v-if="!$route.path.includes('complete') && paymentSuccess" class="progress my-4 mx-5" style="height: 8px;">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                         style="width: 100%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <div class="bg-light shadow-sm rounded p-3 p-sm-4 mb-4 pt-0">
                    <slot name="content">
                        <keep-alive>
                            <transition name="slide-in-left">
                                <router-view></router-view>
                            </transition>
                        </keep-alive>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {navigationComponents} from "../../core/navigation-components";
import {appDataMixin} from "../../core/data/global";
import HorizontalScroll from "../core/horizontal-scroll.vue";

export default {
    name: "bill-shell",
    components: {HorizontalScroll},
    mixins: [navigationComponents, appDataMixin],
    props: ['title', 'subtitle', 'hideCheckTransaction'],
    data: () => ({
        paymentSuccess: true,
    }),
    computed: {
        menuItem() {
            return this.menu.find(m => this.$route.path.startsWith(m.route)) || {};
        },
        currentMenu() {
            return this.services.find(m => this.$route.path.startsWith(m.route)) || {}
        },
        currentMenuSameProvider() {
            return (this.currentMenu.options || []).every(s => !s.provider || s.provider === this.currentMenu.provider) && this.currentMenu.image
        },
        currentActiveMenu() {
            return this.flatServices[this.$route.fullPath]
        },
        currentTitle() {
            return this.title ||
                (this.currentActiveMenu && this.currentActiveMenu.displayName) ||
                (this.currentActiveMenu && this.currentActiveMenu.name)
        },
        currentSubtitle() {
            return this.subtitle ||
                (this.currentActiveMenu && this.currentActiveMenu.displayName) ||
                (this.currentActiveMenu && this.currentActiveMenu.name)
        },
        currentProvider() {
            return (this.currentActiveMenu && this.currentActiveMenu.provider) ||
                (this.currentMenu && this.currentMenu.provider)
        },
        icon() {
            return (this.currentActiveMenu && this.currentActiveMenu.image) ||
                (this.currentActiveMenu && this.currentActiveMenu.icon) ||
                (this.currentMenu && this.currentMenu.image) ||
                (this.currentMenu && this.currentMenu.icon)
        }
    },
    mounted() {
        window.addEventListener('payment-status', this.onPaymentStatus)
    },
    beforeDestroy() {
        window.removeEventListener('payment-status', this.onPaymentStatus)
    },
    methods: {
        onPaymentStatus($event){
          this.paymentSuccess =  $event.detail.status
        }
    }
}
</script>

<style scoped>
.nav-link {
    color: rgba(0, 0, 0, 0.5) !important;
    border-radius: 0;
    vertical-align: bottom;
}

.nav-link.active {
    background-color: var(--primary-color) !important;
    border-left: 4px solid var(--accent-color) !important;
    color: #fff !important;
}

.nav-link.active img {
    filter: brightness(0) invert(1);
}

.bill-img {
    height: 20px;
    width: calc(16px * 4);
    object-fit: contain;
}

.bill-img.bill-img-lg {
    height: 64px;
    width: auto;
    max-width: 64px;
    border-radius: 6px;
    border: 1px #eee solid;
    padding: 0.4rem;
    object-fit: contain;
}

.currency-flag, .icon {
    height: 12px;
    object-fit: contain;
}

.currency-flag {
    height: 12px;
}

.icon {
    height: 16px;
}
</style>
